module.exports = __webpack_public_path__ + "img/ES3045.5c45541c.png";